import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "divide",
  "use": "divide-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"divide\">\n<path d=\"M12,9c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S13.7,9,12,9z M12,5c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S12.6,5,12,5z\" />\n<path d=\"M19,13H5c-0.6,0-1-0.4-1-1s0.4-1,1-1h14c0.6,0,1,0.4,1,1S19.6,13,19,13z\" />\n<path d=\"M12,21c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S13.7,21,12,21z M12,17c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S12.6,17,12,17z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol